import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { PopupMainContent } from "../../components/Popup/Components";
import { Form, Formik } from "formik";
import { Col, NavLink, Row } from "react-bootstrap";
import FormInput from "../../components/Form/FormInput/FormInput";
import { uid } from "../../helper";
import moment from "jalali-moment";
import { DetailsInfoCard, DetailsInfoRow } from "../../components/Table/Components";
import { useApp } from "../../hooks/useApp";
import { useCallback, useEffect, useState } from "react";
import SearchableDropdown from "../../components/Form/Dropdown/SearchableDropdown";
import PrimaryButton from "../../components/Form/Button/PrimaryButton";
import FormDatePicker from "../../components/Form/DatePicker/FormDatePicker";
import CommonService from "../../services/common.service";
import { SubscriptionDate } from "../../components/General/SubscriptionDate";
import { Amount } from "../../components/General/Amount";
import { PaymentStatus } from "./PaymentStatus";
import Button from "../../components/Form/Button/Button";
import YupValidation from "../../components/Form/Validations/YupValidaion";
import PaymentsService from "../../services/payments.service";
import { useModal } from "../../hooks/useModal";
import { useDataTable } from "../../hooks/useDataTable";

export const USDTPaymentView = ({context, data}) => {
    const {t} = useTranslation();
    const [formData, setFormData] = useState(data);
    const {paymentGateways, exceptionHandler, displayToast} = useApp();
    const {updateRowDataTable} = context;
    const {closeModal} = useModal();
    const [action, setAction] = useState("");

    const initialValues = {
        description: formData.result_description
    };

    const approveSchema = Yup.object().shape({});

    const declinedSchema = Yup.object().shape({
        description: YupValidation.EmptyValidation(t("Description")),
    });

    const handleSubmit = (values, actions) => {
        PaymentsService.approval(formData.id, action, values.description).then((result) => {
            setFormData(result);
            setTimeout(() => {
                updateRowDataTable(result);
                displayToast(t("Update was successful."), 'success');
                closeModal();
            }, 100)
        })
        .catch((error) => {
            console.log(error)
            exceptionHandler(error, actions)
        })
        .finally(() => actions.setSubmitting(false));
    };
    return (
        <PopupMainContent $maxWidth="700px">
            <Formik
                initialValues={initialValues}
                validationSchema={action === "approve"?approveSchema:declinedSchema}
                onSubmit={handleSubmit}
            >
                {(formik) => (
                    <Form>
                        <DetailsInfoCard>
                            <DetailsInfoRow>
                                <b>{t("Account Number")}</b> <span><b>{uid(formData.uid)}</b></span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Invoice Number")}</b> <span>{formData.order.order_id}</span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Method")}</b> <span><b>{paymentGateways?.[formData.payment_gateway]}</b></span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Date")}</b> <span>{moment(formData.created_at).format("D MMMM YYYY")}</span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Time")}</b> <span>{moment(formData.created_at).format("HH:mm:ss")}</span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Amount")}</b> <span><Amount currency={formData.order.currency} amount={formData.order.price} /></span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Plan")}</b> <span>{formData.order.plan.name?.['en']}</span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Hash Code")}</b> <span><a href={`https://tronscan.org/#/transaction/${formData.transaction_id}`} target="_blank">Go to Tronscan</a></span>
                            </DetailsInfoRow>
                            <DetailsInfoRow>
                                <b>{t("Status")}</b> <span><PaymentStatus row={formData} label={true}/></span>
                            </DetailsInfoRow>
                            
                            
                            
                        </DetailsInfoCard>
                        <Row>
                            <Col md={12}>
                                <FormInput type="textarea" name="description" theme={"light"} label={t("Description")} formik={formik} />    
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <PrimaryButton type="submit" full submitting={formik.isSubmitting} onClick={() => setAction("approve")} disabled={formData.status === 1}>{t("Approve")}</PrimaryButton>
                            </Col>
                            <Col md={6}>
                                <Button variant={"danger"} type="submit" full submitting={formik.isSubmitting } onClick={() => setAction("declined")} disabled={formData.status === 3}>{t("Declined")}</Button>
                            </Col>
                        </Row>
                        
                        
                    </Form>
                )}
                
            </Formik>
        </PopupMainContent>
    )
}